<template>
    <div v-if="chartData.datasets.length > 0">
        <Bar :data="chartData" :options="chartOptions" :style="style" />
    </div>
    <div v-else>
        Carregando dados...
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
} from 'chart.js'
import { Bar } from 'vue-chartjs'
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import { defineProps } from 'vue';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const props = defineProps({
  year: Number
});

const chartData = ref({
    labels: [],
    datasets: []
});

const chartOptions = ref({
    responsive: true,
    maintainAspectRatio: false
});

const style = ref({
    height: '336px', // Set your desired height here
    width: '100%',
    position: 'relative',
});



onMounted(async () => {
    try {
        const response = await api.get('/dashboard-financial/annualChartReceivablePayable', {params: {'year': props.year}}).then((response)=>{return response;}).catch((error)=>{handleRequestErrors(error.status)});
       
        const apiData = response.data.data;
        console.log(apiData);
        chartData.value = {
            labels: apiData.labels,
            datasets: [
                {
                    label: 'Receitas',
                    borderColor: 'rgba(1,97,38, 0.8)',
                    borderWidth: 2,
                    tension: 0.1,
                    backgroundColor: 'rgba(1,97,38, 0.3)',
                    data: apiData.receivable
                },
                {
                    label: 'Despesas',
                    borderColor: 'rgba(128,3,3, 0.8)',
                    borderWidth: 2,
                    tension: 0.1,
                    backgroundColor: 'rgba(128,3,3, 0.3)',
                    data: apiData.payable
                }
            ]
        };
    } catch (error) {
        console.error('Error fetching data:', error);
    }
});

</script>